"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAppComponent = void 0;
var react_1 = __importStar(require("react"));
var Sky_Smartphone_download_png_1 = __importDefault(require("../../../../assets/Sky_Smartphone_download.png"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_router_dom_1 = require("react-router-dom");
var GetAppComponent = function (props) {
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "grid grid-cols-1 lg:grid-cols-2 relative h-[800px]  md:h-[400px]  rounded-xl" },
        react_1.default.createElement("div", { className: "flex flex-col items-center px-0 max-h-[400px] justify-center" },
            react_1.default.createElement("div", { className: "flex flex-col items-start gap-4 p-" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-left", label: "App download available!", size: "5xlarge", textColor: "text-primary", bold: true }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-left", label: "Discover a whole new level of convenience with the Sky LifeStyle's innovative app.", size: "medium", textColor: "text-grey-300" })),
            react_1.default.createElement("div", { className: "flex pt-5 w-full" },
                react_1.default.createElement(doshx_controls_web_1.AppStoreButtonsControl, { orientation: "horizontal", size: "medium", appStore: {
                        onClick: function () {
                            window.open("https://apps.apple.com/us/app/skylifestyle-mobile/id6456845292", "_blank");
                        },
                    }, playStore: {
                        onClick: function () {
                            window.open("https://play.google.com/store/apps/details?id=skylifestyle.mobile", "_blank");
                        },
                    } }))),
        react_1.default.createElement("div", { className: "lg:px-0 relative rounded-xl h-[400px] flex flex-col justify-center items-center" },
            react_1.default.createElement("img", { className: "h-full object-cover rounded-t-lg md:rounded-l-lg", src: Sky_Smartphone_download_png_1.default }))));
};
exports.GetAppComponent = GetAppComponent;
